import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

/**
 * OS 의 "동작 줄이기" 설정. 문서의 무음 루프 영상 자동재생을 끄는 데 쓴다.
 * 초기값을 false 로 두면 설정을 켠 사용자에게도 한 프레임 재생됐다가 멈춘다 —
 * 그래서 첫 렌더에서 바로 matchMedia 를 읽는다(SSR/prerender 대비 guard 포함).
 */
export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(QUERY).matches,
  );

  useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const onChange = () => setReduced(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return reduced;
}
